import {
    CHALLENGE_DESIGN_COST,
    EXCHANGE_RATES,
    TEAM_COMPOSITION,
} from './calculatorConstants';
import {
    HOURS_PER_WORK_MONTH,
    applyRoundingRules,
    calculateMilestonesCount,
    calculateTranchesCount,
} from './calculatorHelpers';
import type { CalculatorCosts, CalculatorFormState } from './types';

export const calculateCosts = (formData: CalculatorFormState): CalculatorCosts => {
    const selectedChallenge = formData.challenges[0] || '';
    const designCost = selectedChallenge ? CHALLENGE_DESIGN_COST[selectedChallenge] || 0 : 0;

    const calculationTeam: Record<string, number> = { ...formData.teamComposition };

    if ('developer2' in calculationTeam && 'developer' in calculationTeam) {
        calculationTeam.developer =
            (calculationTeam.developer || 0) + (calculationTeam.developer2 || 0);
        calculationTeam.developer2 = 0;
    }

    let sumOfRoles = 0;
    Object.entries(calculationTeam).forEach(([role, roleFTE]) => {
        if (role === 'developer2') return;
        if (roleFTE > 0) {
            const member = TEAM_COMPOSITION[role] || { hourlyRate: 0 };
            sumOfRoles += roleFTE * member.hourlyRate;
        }
    });

    const totalLaborCost = sumOfRoles * HOURS_PER_WORK_MONTH * formData.projectDuration;

    const trancheCount = calculateTranchesCount(formData.projectDuration);
    const milestones = calculateMilestonesCount(trancheCount);

    const exchangeInfo =
        formData.workshopType && formData.workshopType in EXCHANGE_RATES
            ? EXCHANGE_RATES[formData.workshopType]
            : { currency: 'EUR', rate: 1 };

    const roundedDesignCost = applyRoundingRules(designCost * exchangeInfo.rate);
    const finalTotal = applyRoundingRules(totalLaborCost * exchangeInfo.rate);
    const costPerTranche = trancheCount > 0 ? Math.round(finalTotal / trancheCount) : 0;
    const tranchesTotalCost = costPerTranche * trancheCount;

    return {
        designCost: roundedDesignCost,
        tranchesTotalCost,
        trancheCount,
        costPerTranche,
        totalLaborCost,
        total: finalTotal + roundedDesignCost,
        milestones,
        currency: exchangeInfo.currency,
    };
};
